<template>
  <span class="flex flex-row gap-3">
    <NuxtLink
      v-if="to"
      :class="{ ...classes, 'text-link': true }"
      :to="to"
      :data-uuid="value"
      :data-short="short ? '1' : '0'"
    >
      <abbr
        v-if="short"
        :title="value || ''"
        :class="{
          'text-green decoration-green-500 decoration-dotted hover:decoration-solid': true,
        }"
        >{{ valueF }}</abbr
      >
      <span v-else>{{ valueF }}</span>
    </NuxtLink>
    <span
      v-else
      :class="classes"
      :data-uuid="value"
      :data-short="short ? '1' : '0'"
    >
      <abbr v-if="short" :title="value || ''" :class="'decoration-dotted'">{{
        valueF
      }}</abbr>
      <span v-else>{{ valueF }}</span>
    </span>
    <CopyButton v-if="copy" :value="value || ''" />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore3 } from '~/store/main';
import CopyButton from '~/components/CopyButton.vue';

const props = withDefaults(
  defineProps<{
    value?: string | null;
    to?: string;
    short?: boolean;
    copy?: boolean;
  }>(),
  {
    value: '',
    to: '',
    short: false,
    copy: false,
  },
);
const store3 = useStore3();
const classes = computed(() => {
  return { 'text-ellipsis': props.short, 'align-middle': true };
});
const valueF = computed(() => {
  if (store3?.regressionTest) {
    return 'id';
  } else if (!props.value) {
    return '-';
  } else {
    return props.value;
  }
});
</script>
